import './dropdown.style.scss';
import React, { useEffect, useImperativeHandle, useRef, useState } from 'react';
import { __DropDownOption, __DropDownProps, __DropDownRef } from './dropdown.interface';
import useOnBlur from 'scripts/useOnBlur';
import { OverlayTrigger } from 'react-bootstrap';
import { Language, ReduxState, TextDirection } from 'interface';
import { connect, ConnectedProps } from 'react-redux';
import HintText from '../hintText/hintText.index';
import QuestionImage from '../questionImage/questionImage.index';
import { extractTitle } from 'scripts/string';
export interface SLPDropDownRef extends __DropDownRef {}
export interface SLPDropDownOption extends __DropDownOption {}

const SLPUCheckDropdown: React.ForwardRefRenderFunction<
    __DropDownRef,
    ConnectedProps<typeof connector> & __DropDownProps
> = function (props: ConnectedProps<typeof connector> & __DropDownProps, ref) {
    const lang = props.lang.utilities;
    const [selected, setSelected] = useState<__DropDownOption>();
    const [error, setError] = useState<string>();
    const [isOpen, setOpen] = React.useState(false);
    const [menuWidth, setMenuWidth] = useState<string>();
    const dropRef = useRef<HTMLDivElement>(null);
    const immediateValue = useRef<__DropDownOption>();
    const [options, setOptions] = useState(props.options);
    const inputRef = useRef<HTMLInputElement>(null);
    const labelRef = useRef<HTMLLabelElement>(null);

    useImperativeHandle(ref, () => ({
        setError: (text) => setError(text),
        setValue: (e) => {
            immediateValue.current = e;
            setSelected(immediateValue.current);
        },
        getValue: () => immediateValue.current,
    }));

    useEffect(() => {
        immediateValue.current = props.value ? props.value : props.defaultValue ? props.defaultValue : undefined;
        setSelected(immediateValue.current);
    }, [props.value, props.defaultValue]);

    function onSelectHandler(e?: __DropDownOption) {
        immediateValue.current = e;
        setSelected(immediateValue.current);
        setOpen(false);
        setError(undefined);
        if (props.onChange) props.onChange(e);
    }

    useOnBlur(dropRef, () => setOpen(false));

    useEffect(() => {
        if (isOpen) setMenuWidth(dropRef.current?.clientWidth.toString());
    }, [isOpen]);

    useEffect(() => {
        setOptions(props.options);
    }, [props.options]);

    useEffect(() => {
        if (labelRef.current && props.label) labelRef.current.innerHTML = extractTitle(props.label, false);
    }, [props.label]);

    return (
        <div
            ref={dropRef}
            className={`ucheck-SLP-drop-down ${isOpen ? 'active' : ''} ${
                props.dir === TextDirection.rtl ? 'rtl-text' : ''
            }`}
        >
            <span className="d-flex">
                {props.required && <span className="required-star">*</span>}
                <span className="counter-span">{props.counter ? props.counter + '- ' : ''}</span>
                <label ref={labelRef} style={{ color: props.labelColor }} />
            </span>
            <QuestionImage src={props.image?.file} />
            <HintText value={props.hint} />
            <OverlayTrigger
                show={isOpen}
                overlay={
                    <div
                        className={`ucheck-SLP-dropdown-menu ${props.dir === TextDirection.rtl ? 'rtl-text' : ''}`}
                        style={{ minWidth: menuWidth + 'px' }}
                    >
                        {options.filter((i) => !i.archive && !i.isHidden).length ? (
                            options
                                .filter((i) => !i.archive && !i.isHidden)
                                .map((item, index) => (
                                    <span
                                        onClick={() => {
                                            onSelectHandler(item);
                                        }}
                                        key={index}
                                        className="drop-down-item"
                                        style={{ color: props.color }}
                                        dangerouslySetInnerHTML={{ __html: item.title }}
                                    ></span>
                                ))
                        ) : (
                            <span
                                onClick={() => {
                                    if (inputRef.current) inputRef.current.value = '';
                                }}
                                className="drop-down-item"
                                style={{ color: props.color }}
                            >
                                {lang.noItem}
                            </span>
                        )}
                    </div>
                }
                placement="bottom-end"
            >
                <div className="dropdown-box">
                    <input
                        onBlur={() => {
                            setOpen(false);
                            if (inputRef.current) inputRef.current.value = '';
                        }}
                        onFocus={() => {
                            setOpen(true);
                            setOptions(props.options);
                        }}
                        placeholder={
                            props.placeholder
                                ? props.placeholder
                                : props.formLang === Language.en
                                ? lang.SLPDropDownPHEn
                                : lang.SLPDropDownPH
                        }
                        value={selected?.title}
                        type="text"
                        ref={inputRef}
                        onChange={(e) => {
                            immediateValue.current = undefined;
                            setSelected(immediateValue.current);
                            setOptions(props.options.filter((i) => i.title.includes(e.target.value)));
                        }}
                    />
                    <i className="ufi ufi-chevron-down" />
                </div>
            </OverlayTrigger>
            {error && <p className="input-error">{error}</p>}
        </div>
    );
};

const mapStateToProps = (state: ReduxState) => ({
    direction: state.direction,
    isAuth: state.authStatus,
    lang: state.lang,
});

const connector = connect(mapStateToProps, null, null, { forwardRef: true });
export default connector(React.forwardRef(SLPUCheckDropdown));
